export default __webpack_public_path__ + "static/media/correct.369c0cd9.mp3";